import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import styled from "styled-components";

const StyledToolTip = ({
  children,
  title,
  placement = "top",
  className = "",
  childrenClass = "",
}) => {
  return (
    <OverlayTrigger
      overlay={
        <StyledTooltip className={`${className}`}>{title}</StyledTooltip>
      }
      placement={placement}
    >
      <span
        className={`d-flex align-items-center cursor-pointer ${childrenClass}`}
      >
        {children}
      </span>
    </OverlayTrigger>
  );
};

const StyledTooltip = styled(Tooltip)`
  .tooltip-arrow {
    &:before {
      display: none;
    }
  }

  .tooltip-inner {
    background-color: ${({ theme }) => theme.colors.secondary};
    font-family: ${({ theme }) => theme.fonts.body};
    color: ${({ theme }) => theme.colors.white};
    padding: 5px 12px;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

export default StyledToolTip;
